import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { creditScoreService } from "../../services/creditScore.service";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import moment from "moment";
import { rankColor } from "./creditScoreRank";
import { GetCreditScoreList, SetCreditScoreList } from "../../store/creditScoreAtom";


const columns = [
  {
    title: "ID",
    dataIndex: "customer_id",
    className: "text-primary",
    sorter: (a, b) => (a?.customer_id ?? 0) - (b?.customer_id ?? 0),
  },
  {
    title: "Name",
    dataIndex: "customer_full_name",
    className: "text-primary font-bold",
    sorter: (a, b) => (a?.customer_full_name ?? "").localeCompare(b?.customer_full_name ?? ""),
  },
  {
    title: "Email",
    dataIndex: "customer_email_address",
    sorter: (a, b) => (a?.customer_email_address ?? "").localeCompare(b?.customer_email_address ?? ""),
  },
  {
    title: "Mobile",
    dataIndex: "customer_mobile_no",
    sorter: (a, b) => (a?.customer_mobile_no ?? "").localeCompare(b?.customer_mobile_no ?? ""),
  },
  {
    title: "Status",
    dataIndex: "customer_status_name",
    sorter: (a, b) => (a?.customer_status_name ?? "").localeCompare(b?.customer_status_name ?? ""),
    render: (record) => (
      <span className={record === "Active" ? "text-green-500 font-bold" : "text-gray-500"}>{record}</span>
    ),
  },
  {
    title: "Final Score",
    dataIndex: "final_score",
    sorter: (a, b) => (a?.final_score ?? 0) - (b?.final_score ?? 0),
    render: (record) => <span className="font-bold">{record}</span>,
  },
  {
    title: "Rank",
    dataIndex: "score_rank",
    sorter: (a, b) => (a?.final_score ?? 0) - (b?.final_score ?? 0),
    render: (record) => <span className={rankColor[record] ?? ""}>{record}</span>,
  },
  {
    title: "Eligible Baskets",
    dataIndex: "eligible_food_baskets",
    sorter: (a, b) => (a?.eligible_food_baskets ?? "").localeCompare(b?.eligible_food_baskets ?? ""),
    render: (record) => record || "-",
  },
  {
    title: "Processed On",
    dataIndex: "processed_date",
    sorter: (a, b) => (a?.processed_date ?? "").localeCompare(b?.processed_date ?? ""),
    render: (record) => (record ? moment(record).format("DD-MM-YYYY HH:mm") : ""),
  },
];

function CreditScoreMainPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  const getCreditScore = GetCreditScoreList();
  const setCreditScore = SetCreditScoreList();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    document.title = "Credit Score";
    let isMounted = true;
    if (getCreditScore.credit_score?.length) {
      setTableData(getCreditScore.credit_score);
    } else {
      loadCreditScore(() => isMounted);
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadCreditScore = (isMounted = () => true) => {
    creditScoreService.getCreditScoreList().then((res) => {
      if (res?.data && isMounted()) {
        setCreditScore(res.data);
        setTableData(res.data.credit_score ?? []);
      }
    });
  };

  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: tableData.length,
  };

  function handleRowClick(row) {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${row?.customer_id}`);
  }

  return (
    <>
      <div className="flex flex-row items-center justify-between">
        <Tooltip title="Reload">
          <RestartAlt
            className="cursor-pointer text-blue-600 hover:text-blue-800 transition-colors self-center"
            onClick={() => loadCreditScore()}
            color="primary"
            fontSize="large"
          />
        </Tooltip>
      </div>

      <section className="mt-5">
        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={false}
          paginationOptions={paginationOptions}
          rowKey={(record) => record?.customer_id}
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
}

export default CreditScoreMainPage;
